<template>
    <div class="settings-index">
            <div class="account">
                <div class="grid">
                    <div class="field-group" style="margin-bottom:20px;">
                            <label>{{ $page.props.lang.choose_photo || "Select a Logo" }}</label>
                            <div v-if="mainLogoPath != ''">
                                <div :style="{backgroundColor: $page.props.organization.themeOptions.primary, marginBottom: '5px', padding: '10px'}">
                                    <img  :src="organizationPhotoUrl" alt=""></div>
                                <div>
                                    <v-btn tile color="primary" small @click="deletePhotoModal = true"><v-icon small class="mr-1">mdi-close</v-icon>
                                    {{ $page.props.lang.remove || "Remove" }}
                                    </v-btn>
                                </div>
                            </div>
                            <div class="container" v-else>
                            <v-row>
                                <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                                    <div>
                                    <v-file-input
                                    chips
                                    small-chips
                                    outlined
                                    dense
                                    v-model="organizationPhoto"
                                    prepend-icon="mdi-camera-enhance"
                                    :label="$page.props.lang.choose_photo || 'Choose Logo'"
                                    @change="onFileChange"
                                    >
                                        </v-file-input>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div class="field-group" style="margin-bottom:20px;">
                        <label>{{ $page.props.lang.pickPrimaryColor || "Pick a Primary Color" }}</label>
                        <v-color-picker v-model="themeOptions.primary"></v-color-picker>
                    </div>
                </div>
                <div class="column button-wrap" style="margin-top:20px;">
                        <v-btn @click="saveSettings" color="primary" width="160">
                            {{ $page.props.lang.save || 'Save' }}
                        </v-btn>
                    </div>
                </div>
            <ConfirmModal
                :title="$page.props.lang.confirmModalTitle || 'Confirmation'"
                :description="$page.props.lang.delete_photo_confirmation_description || 'If you click YES, the logo will be deleted. Are you sure?'"
                :open="deletePhotoModal"
                @no="deletePhotoModal = false"
                @yes="deletePhoto"
                @close="deletePhotoModal = false">
            </ConfirmModal>
        </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import EventBus from '@/js/eventbus'
import ConfirmModal from '@/js/Components/ConfirmModal'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.theme || "Theme"
        }
    },
    components: {
        ConfirmDelete,
        ConfirmModal
    },
    props: {
        mainLogoPath: String,
        themeOptions: Object
    },
    data() {
        return {
            toReturn: this.themeOptions,
            imageLoading: false,
            deletePhotoModal:false,
            organizationPhoto: null,
            organizationPhotoUrl: '/media/thumbnail' + this.mainLogoPath,
            responseErrors: {}
        }
    },
    methods: {
        saveSettings() {
            axios.post('/backoffice/settings/saveOptions', this.toReturn)
                .then(response => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    });
                    if (response.data.status==="OK") {
                        location.reload();
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
        onFileChange() {
                this.imageLoading = true;
                let file =  this.organizationPhoto;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                formData.append('file', file);

                axios.post('/backoffice/settings/upload', formData, config)
                    .then(response => {
                        if (response.data.status==="OK") {
                            this.imageLoading = false;
                            this.organizationPhotoUrl = response.data.main_logo_path;
                            this.$inertia.reload();

                            EventBus.$emit('SHOW_NOTIFICATION', {
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        }
                    })
                    .catch(error => {
                        this.imageLoading = false

                         if(error) {
                            this.organizationPhoto = null;
                            EventBus.$emit('SHOW_NOTIFICATION',{
                                    message: error.response.data.message,
                                    color: 'error',
                                    timeout: 10000
                                })
                        }
                    })

        },
        deletePhoto(){
            axios.post('/backoffice/settings/removePhoto')
                    .then(response => {
                        if (response.data.status==="OK") {
                            this.deletePhotoModal = false;
                            this.$inertia.reload();
                            this.organizationPhoto = null;

                        EventBus.$emit('SHOW_NOTIFICATION', {
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        }
                    })
                    .catch(error => {

                    })
        }
    }
}
</script>
